import { useMutation, useQueryClient } from '@tanstack/react-query';
import { message } from 'antd';

import type { ExperienceResponse } from 'app/typings/core/admin/experiences/experience';
import type { CreateExperienceRequest } from 'app/typings/core/admin/experiences/experienceForm';
import { apiMutation } from 'app/utils/request/api';

import { CORE_QUERY_KEYS, ENDPOINTS } from '.';

export function useCreateExperience() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload: CreateExperienceRequest) =>
      apiMutation(
        'POST',
        { path: ENDPOINTS.createExperience },
        payload
      ) as Promise<ExperienceResponse>,
    onSuccess: (response) => {
      message.success('Activity successfully created');

      queryClient.invalidateQueries({
        queryKey: [CORE_QUERY_KEYS.experiences],
        exact: false,
      });

      queryClient.setQueryData(
        [CORE_QUERY_KEYS.experience, { id: response.id.toString() }],
        response
      );
    },
    onError: () => {
      message.error('Failed to create activity.');
    },
  });
}
